module.exports = __webpack_public_path__ + "img/main-0.a87fdb0a.webp";